// 告知バーの高さを設定
// document.documentElement.style.setProperty(
//   "--announcement-bar-height",
//   `${Math.round(
//     document.getElementById("shopify-section-{{ section.id }}").clientHeight
//   )}px`
// );

// URLパラメータを追加する関数
function addUrlParameter(param) {
  try {
    const url = new URL(window.location);
    const params = new URLSearchParams(param);

    // 新しいパラメータを既存のURLSearchParamsに追加
    params.forEach((value, key) => {
      url.searchParams.set(key, value);
    });

    // ページ遷移
    window.location.href = url.toString();
  } catch (error) {
    console.error("URLパラメータの追加に失敗しました:", error);
    // フォールバック: 単純にパラメータを追加
    const separator = window.location.search ? "&" : "?";
    window.location.href = window.location.href + separator + param;
  }
}
